import { render, staticRenderFns } from "./GlobalPagination.vue?vue&type=template&id=57ab603d&"
import script from "./GlobalPagination.vue?vue&type=script&lang=js&"
export * from "./GlobalPagination.vue?vue&type=script&lang=js&"
import style0 from "./GlobalPagination.vue?vue&type=style&index=0&id=57ab603d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports